export default __webpack_public_path__ + "static/media/couple@2x.12e4ddc1.jpg";